export default "__VITE_ASSET__2sI4UP3V__"